import { Component, OnDestroy, OnInit, Input } from '@angular/core';
import { WidgetComponent } from '../core/widget.component';
import { ReportsService } from '../../../@apiClient/extensions';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'table-component-with-link',
  styleUrls: ['./table.component.scss'],
  templateUrl: './table.component.html',
})
export class TableComponent extends WidgetComponent implements OnInit, OnDestroy {

  constructor(private router: Router, private route: ActivatedRoute, reportsService: ReportsService) {
    super(reportsService);
  }

  ngOnInit() {

  }

  ngOnDestroy() {

  }

  public onClickListRow(documentId: string) {

    this.router.navigate(['documents/details/', documentId], { relativeTo: this.route.root });
  }
}
